import RuleDepends from './RuleDepends'

export default class Same extends RuleDepends {
  get ruleName () {
    return 'same'
  }

  passes () {
    return this.value === this.data[this.dataAttribute]
  }

  message () {
    return this.replaceMessage(super.message(), 'other', this.tradAttribute(this.dataAttribute))
  }
}
